export default "__VITE_ASSET__hSAyuHQu__"